import { InputText } from 'components';
import { Loading } from 'components';
import { Button, InputWraper } from 'modules';
import React from 'react';
import { MainRouteKeys } from 'routes/enums';
import { useNavigate } from 'react-router-dom';
import { useGetBalanceQuery } from 'services';

const BalanceRewardManagementFeatures = (): JSX.Element => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetBalanceQuery();

  const nomorlizeBalance = (balance: number) => {
    return Number(balance).toLocaleString('vi-VN') + ' đ';
  };

  return (
    <div className='container-fluid balance-management'>
      <Loading isLoading={isLoading}>
        <div className='row balance-management__wrap'>
          <div className='col-8 col-lg-4'>
            <InputWraper
              label='Điểm thưởng'
              component={InputText}
              inputProps={{
                value: data ? nomorlizeBalance(data.balance) : '',
                name: 'balance',
                isDisabled: true,
                onChange: () => {},
                onTouched: () => {},
              }}
            />
          </div>

          <div className='col-12 balance-management__action'>
            <Button
              className='balance-management__action__transfer ml-3'
              label={'Nạp điểm từ OTBiz Pay'}
              type='button'
              buttonType='success'
              onClick={() => navigate(MainRouteKeys.DepositFromMoraPay)}
            />

            <Button
              className='balance-management__action__transfer ml-3'
              label={'Rút điểm thưởng ra OTBiz Pay'}
              type='button'
              buttonType='success'
              onClick={() => navigate(MainRouteKeys.WithdrawToMoraPay)}
            />
          </div>
        </div>
      </Loading>
    </div>
  );
};

export default BalanceRewardManagementFeatures;
